var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.goodsList && _vm.goodsList.length)?_c('div',{staticClass:"guess-like"},[_c('div',{staticClass:"title"},[_vm._v("猜你喜欢")]),_c('div',{staticClass:"product-list-body"},_vm._l((_vm.goodsList),function(item,index){return _c('index-product-body',{key:index,attrs:{"item":item,"index":index}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }